/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Load_MoreInputs */

const vi_list_load_more = /** @type {(inputs: List_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem thêm`)
};

/**

* @param {List_Load_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const list_load_more = /** @type {((inputs?: List_Load_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Load_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_list_load_more(inputs)
});